export default "__VITE_ASSET__ER8GxJMb__"